export default __webpack_public_path__ + "static/media/xsp.41d504b9.gif";